"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var OverlayConverter_1 = require("./OverlayConverter");

var SubtitleTrackConverter_1 = require("./SubtitleTrackConverter");

var VideoSourceConverter_1 = require("./VideoSourceConverter");

var SceneConverter =
/** @class */
function () {
  function SceneConverter() {}

  SceneConverter.prototype.fromMessage = function (message) {
    var object = {
      id: message.id,
      videoSource: VideoSourceConverter_1.videoSourceConverter.fromMessage(message.videoSource)
    };
    if (utils_1.hasValue(message.overlays)) object.overlays = message.overlays.map(function (x) {
      return OverlayConverter_1.overlayConverter.fromMessage(x);
    });
    if (utils_1.hasValue(message.subtitles)) object.subtitles = message.subtitles.map(function (x) {
      return SubtitleTrackConverter_1.subtitleTrackConverter.fromMessage(x);
    });
    return object;
  };

  SceneConverter.prototype.toMessage = function (object) {
    var message = {
      id: object.id,
      videoSource: VideoSourceConverter_1.videoSourceConverter.fromMessage(object.videoSource)
    };
    if (utils_1.hasValue(object.overlays)) message.overlays = object.overlays.map(function (x) {
      return OverlayConverter_1.overlayConverter.toMessage(x);
    });
    if (utils_1.hasValue(object.subtitles)) message.subtitles = object.subtitles.map(function (x) {
      return SubtitleTrackConverter_1.subtitleTrackConverter.toMessage(x);
    });
    return object;
  };

  return SceneConverter;
}();

exports.SceneConverter = SceneConverter;
exports.sceneConverter = new SceneConverter();